<template>

	<div class="gray-bg" style="min-height: 100vh">

		<div class="middle-box text-center loginscreen   animated fadeInDown">
      <div>

        <div>
          <a target="_blank" href="https://www.snatchpark.com/parkbills/">
            <img src="/static/image/parkbills.png">
          </a>
          <img src="/static/image/park_bills_text_black.png">
        </div>
        
        <h3>ParkBills Verify Email</h3>
        
        <form class="m-t" role="form">
					
					<div class="form-group">
						<input v-model="email" type="email" class="form-control" placeholder="Email" required="">
					</div>
					
					<div class="form-group">
						<input v-model="link" type="url" class="form-control" placeholder="Link" required="">
					</div>
					
          <h3 class="smaller lighter grey" v-show="isLoading"><i class="fa fa-spin fa-spinner"></i></h3>
          <label class="error form-control-feedback" >{{ error }} </label>
          <label class="text-info form-control-feedback" >{{ result }} </label>
					
					<button type="submit" class="btn btn-primary block full-width m-b btn-snatch" @click.prevent="handleSubmit">
						Verify
					</button>

          <!-- <p class="text-muted text-center"><small>Already have an account?</small></p> -->
          <!-- <a class="btn btn-sm btn-white btn-block" v-bind:href="helper.WEB_URL + '/login'">Login</a> -->
          <!-- <a class="btn btn-sm btn-white btn-block" v-bind:href="helper.WEB_URL + '/register'">Register</a> -->
        </form>
				
				<p class="m-t">
					<small><strong>Copyright</strong> PARKAIDE &copy; 2018</small>
				</p>

      </div>
    </div>
    
  </div>

</template>

<script>
import helper from "@/components/Utility/Helper"

export default {
  name: "PageVerify",
  data(){
    return {
      helper: helper,

      email: '',
      link: '',

      isLoading: false,
      error : null,
      result  : null,
    }
  },
  mounted() {
    if(window.location.href.includes('localhost')) {
      document.title = 'Localhost';
    } else if(window.location.href.includes('parkbills.parkaidemobile.com')) {
      document.title = 'ParkBills Dev';
    } else if(window.location.href.includes('devpbills.parkaidemobile.com')) {
      document.title = 'ParkBills Dev';
    }

    this.email = this.$route.query.email;
    this.link = this.$route.query.link;
  },
  methods : {
    handleSubmit(e){
      if(this.isLoading) {
        return;
      }
      
      if (this.email.length > 0 && this.link.length > 0) {
        this.isLoading = true;
        this.error = '';
        this.result = '';

        this.$http
          .post(helper.API_URL + '/api2/proxy', {
            email: this.email,
            url: this.link,
          })
          .then(response => {
            let resultMeta = helper.processAxiosResponse(this, response);
            this.isLoading = false;
            this.result = `Your password is ${response.data.password}.`;
          })
          .catch((error) => {
            this.isLoading = false;
            this.error = 'Problem registering account. ' + this.parseLoginError(error);
          });
      } else {
        this.error = 'Please fill in required info before proceed.';
      }
    },
    parseLoginError(error) {
      if(error) {
        if(error.response) {
          if(error.response.data) {
            if(error.response.data.message) {
              return error.response.data.message;
            }

            if(typeof a_string === 'string') {
              return error.response.data;
            }
          }

          if(typeof a_string === 'string') {
            return error.response;
          }
        }
      }

      return 'Please try again.'
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Page/User/PageVerify.vue